import React from "react";

export default function ImprintPage() {
  return (
    <div className="page legal-page">
      <section className="page-section legal-hero">
        <p className="eyebrow">Company information · Imprint</p>
        <h1>Agroadviser Solutions Kft.</h1>
        <p className="hero-intro">Legal and contact information for the operator of the Birdwatcher project website.</p>
      </section>

      <section className="page-section compact-section legal-grid">
        <article className="legal-card legal-card-primary">
          <span className="section-label">Service provider</span>
          <h2>Company details</h2>
          <dl className="company-facts">
            <div><dt>Registered full name</dt><dd>Agroadvisor Solutions Korlátolt Felelősségű Társaság</dd></div>
            <div><dt>Abbreviated name</dt><dd>Agroadviser Solutions Kft.</dd></div>
            <div><dt>Registered office</dt><dd>3700 Kazincbarcika, Rózsa út 57., Hungary</dd></div>
            <div><dt>Company registration no.</dt><dd>05-09-039444</dd></div>
            <div><dt>Tax no.</dt><dd>32943805-2-05</dd></div>
            <div><dt>Managing director</dt><dd>Tóth Gergő</dd></div>
            <div><dt>Primary activity</dt><dd>Computer programming</dd></div>
          </dl>
        </article>

        <article className="legal-card">
          <span className="section-label">Contact</span>
          <h2>Electronic contact</h2>
          <p>General and Birdwatcher-related enquiries can be sent to:</p>
          <a className="legal-email" href="mailto:info@agroadvisor.hu">info@agroadvisor.hu</a>
          <p>For privacy-related requests, use the same address and include “Privacy” in the subject line so the request can be routed correctly.</p>
        </article>

        <article className="legal-card">
          <span className="section-label">Website</span>
          <h2>Editorial responsibility</h2>
          <p>The Birdwatcher website is operated by Agroadviser Solutions Kft. Content is provided for informational and professional communication purposes and does not constitute a contractual performance specification unless incorporated into a signed agreement.</p>
        </article>

        <article className="legal-card">
          <span className="section-label">Intellectual property</span>
          <h2>Content and project materials</h2>
          <p>Unless otherwise stated, website text, graphics, project descriptions and original materials are protected content of Agroadviser Solutions Kft. Third-party names and marks remain the property of their respective owners.</p>
        </article>
      </section>
    </div>
  );
}
